import React from "react";
import "./category.css";
import { formatCategoryName } from "../../../../utils/categoryDisplayNames";

interface CategoryProps {
  categoryTitle: string;
  categoryBgImgUrl?: string;
  totalAds?: number;
}

function Category({ categoryTitle, categoryBgImgUrl, totalAds }: CategoryProps) {
  return (
    <div className="category-tile">
      <div className="category-tile__img-wrap">
        <img src={categoryBgImgUrl} alt={categoryTitle} />
      </div>
      <span className="category-tile__name">{formatCategoryName(categoryTitle)}</span>
      {totalAds !== undefined && (
        <span className="category-tile__count">{totalAds} ads</span>
      )}
    </div>
  );
}

export default Category;
